import AmountFormatter from '../libraries/amount-formatter'

export default {

  new() {
    document.addEventListener('DOMContentLoaded', () => {
      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();
    });
  },
  edit() {
    document.addEventListener('DOMContentLoaded', () => {
      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();
    });
  }

}
